module.exports = __webpack_public_path__ + "static/media/glasses.7517b1d5.svg";